import { IAllocationDimension } from "helpers/allocation-dimension";
import { ITargetsData } from "components/product-collection/footer/types";
import { DOORS_COLUMN, ID_COLUMN } from "helpers/validators/import-targets-validator";

export const parseTargetsData = (data: ITargetsData[], allocationDimension: IAllocationDimension): ITargetsData[] => {
    const result: ITargetsData[] = [];
    const deliveryIDs = allocationDimension.dimension_values.map((dimensionValue) => dimensionValue.external_id);
    for (const row of data) {
        const parsedData: ITargetsData = {};
        // Id generated by the parser using the door column and the first N columns before it.
        // This will make checking row uniqueness easier later.
        const id = [];
        for (const [key, value] of Object.entries(row)) {
            // If it's not one of the deliveries, we assume it's a filter column (dept, class, etc.)
            if (!deliveryIDs.includes(key) || key === DOORS_COLUMN) {
                id.push(value);
            }
            parsedData[key] = value.toString();
        }
        if (id.length) {
            // Join the values to create an id for this row.
            // We don't care if it's unique at this point. We will validate that later.
            parsedData[ID_COLUMN] = id.join("_");
            result.push(parsedData);
        }
    }

    return result;
};
